export default {
  green: "#136905",
  crimson: "crimson",
};
